import './CompanyProfileOverview.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import TextInput from 'components/forms/TextInput';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

import CompanyProfileFormField from '../CompanyProfileFormField';

@cxHelpers('CompanyProfileOverview')
export default class CompanyProfileOverview extends PureComponent {
  static propTypes = {
    companyProfile: PropTypes.instanceOf(Map).isRequired,
    isEditing: PropTypes.bool.isRequired,
  };

  // eslint-disable-next-line react/prop-types
  descriptionRenderer = ({ input, ...props }) => (
    <TextInput {...props} {...input} type="textarea" valueOnChange />
  );

  render() {
    const { companyProfile, isEditing } = this.props;

    return isEditing ? (
      <div className={this.cx()}>
        <Box vcenter>
          <h4>
            <Text i18n="hiring.company_profile.jobs_at" />
          </h4>
          <CompanyProfileFormField
            className={this.cxEl('title-field')}
            fieldName="title"
            placeholder={toI18n(
              'hiring.company_profile.company_profile_form.title'
            )}
            editing
          />
        </Box>
        <CompanyProfileFormField
          fieldName="description"
          component={this.descriptionRenderer}
          placeholder={toI18n(
            'hiring.company_profile.company_profile_form.description'
          )}
        />
      </div>
    ) : (
      <div className={this.cx()}>
        <h3 className="mbxl">
          <Text i18n="hiring.company_profile.jobs_at" />
          &nbsp;
          {companyProfile.get('title')}
        </h3>
        <p className={this.cxEl('description')}>
          {companyProfile.get('description')}
        </p>
      </div>
    );
  }
}
